var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAstronaut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 401.4 401.4",
    style: {
      enableBackground: "new 0 0 401.4 401.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D0D7DC"
    },
    d: "M359.45,378.065H41.95V156.641c0-1.105,0.895-2,2-2h313.5c1.105,0,2,0.895,2,2V378.065z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EBF0"
    },
    d: "M352.047,401.399c10.903,0,19.741-8.838,19.741-19.741v-68.562 c0-28.954-22.562-59.864-50.138-68.687l-34.438-12.482c-4.163-1.509-8.8-0.843-12.339,1.818 c-21.673,16.298-50.314,16.306-74.173,16.306s-52.5-0.008-74.173-16.306c-3.539-2.661-8.176-3.327-12.339-1.818L79.749,244.41 c-27.576,8.823-50.138,39.733-50.138,68.687v68.562c0,10.903,8.838,19.741,19.741,19.741H352.047z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D0D7DC"
    },
    d: "M101.603,251.794c26.369,12.338,68.043,21.29,99.097,21.29s72.727-8.952,99.094-21.29 c5.722-2.677,10.805-6.004,15.453-9.705l-28.035-10.161c-4.163-1.509-8.801-0.843-12.339,1.818 c-21.672,16.299-50.314,16.306-74.173,16.306s-52.5-0.008-74.173-16.306c-3.539-2.661-8.176-3.327-12.339-1.818l-28.036,10.161 C90.799,245.79,95.881,249.116,101.603,251.794z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B7BEC9"
    },
    d: "M108.063,228.785l-28.985,10.564c-2.598,0.947-4.327,3.417-4.327,6.183v155.868h39.496V233.113 C114.246,229.915,111.068,227.69,108.063,228.785z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B7BEC9"
    },
    d: "M293.156,228.785l28.985,10.564c2.598,0.947,4.327,3.417,4.327,6.183v155.868h-39.496V233.113 C286.973,229.915,290.152,227.69,293.156,228.785z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EBF0"
    },
    d: "M200.7,0C131.65,0,75.674,36.923,75.674,98.705v85.544c0,27.418,14.822,44.183,32.902,52.643 c22.414,10.487,61.279,19.741,92.124,19.741s69.71-9.254,92.124-19.741c18.079-8.459,32.902-25.225,32.902-52.643V98.705 C325.726,36.923,269.75,0,200.7,0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE1E"
    },
    d: "M286.215,78.964H200.7h-85.516c-10.907,0-19.754,8.833-19.769,19.741v85.544 c0,0.473,0.006,0.941,0.018,1.406c0.462,17.628,15.029,27.861,31.72,33.552c19.301,6.58,51.103,11.302,73.547,11.104 c22.444,0.198,54.246-4.524,73.547-11.104c16.691-5.691,31.257-15.924,31.72-33.552c0.012-0.465,0.018-0.933,0.018-1.406V98.705 C305.969,87.797,297.122,78.964,286.215,78.964z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D0D7DC"
    },
    d: "M271.632,324.081H129.764c-1.105,0-2,0.895-2,2V401.4h145.868v-75.319 C273.632,324.976,272.736,324.081,271.632,324.081z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EBF0"
    },
    d: "M91.884,199.569l-20.869-9.632c-4.661-2.151-7.646-6.816-7.646-11.949v-69.8 c0-5.133,2.985-9.798,7.646-11.949l20.869-9.632V199.569z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EBF0"
    },
    d: "M308.898,199.569l20.869-9.632c4.661-2.151,7.646-6.816,7.646-11.949v-69.8 c0-5.133-2.985-9.798-7.646-11.949l-20.869-9.632V199.569z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 127.764,
    y: 342.588,
    style: {
      fill: "#B7BEC9"
    },
    width: 145.868,
    height: 9.87
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FB4C4"
    },
    d: "M223.32,347.523c0,7.012-5.922,12.749-13.161,12.749h-18.923c-7.238,0-13.161-5.737-13.161-12.749 s5.922-12.749,13.161-12.749h18.923C217.397,334.774,223.32,340.511,223.32,347.523z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD24F"
    },
    d: "M286.215,78.964H200.7h-0.002v151.347h0.002c22.444,0.198,54.246-4.524,73.547-11.104 c16.691-5.691,31.257-15.924,31.72-33.552c0.012-0.465,0.018-0.933,0.018-1.406V98.705 C305.969,87.797,297.122,78.964,286.215,78.964z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstronaut);
export default __webpack_public_path__ + "static/media/astronaut.2bb00e69ca35d9604ca4e8e3e1e78402.svg";
export { ForwardRef as ReactComponent };